import { SignInViewModel } from '@apis/model';
import { toCaptchaViewModel, toOtpViewModel } from '@apis/responseTransformer';
import { LoginResponse } from '@ul/api';

export const toSignInViewModel = (signInResponse: LoginResponse): SignInViewModel => {
    const { success, responseCode } = signInResponse;
    return {
        responseCode,
        success,
        captchaViewModel: toCaptchaViewModel(signInResponse),
        otpViewModel: toOtpViewModel(signInResponse),
    };
};
